var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsEmailOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D2D2D;}\n\t.st1{fill:#7D7D7D;}\n\t.st2{fill:#464646;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#E0301E;}\n\t.st5{fill:#DB536A;}\n\t.st6{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2_4_",
    d: "M83.5,22.5h-63c-2.5,0-4.5,2-4.5,4.5v45c0,2.5,2,4.5,4.5,4.5h63c2.5,0,4.5-2,4.5-4.5V27 C88,24.5,86,22.5,83.5,22.5z M83.5,72h-63V37.6L52,52.7l31.5-15.1V72z M83.5,32.6L52,47.7L20.5,32.6V27h63V32.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsEmailOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Email_Outline_Black_RGB.120719993cf1ff52c153c83e9a0566fb.svg";
export { ForwardRef as ReactComponent };